import type {
  ICampaignTargetCustom,
  ICustomCampaignTargetRule,
} from "@shared/common/custom-target-condition/types";

export const cafe24UserLogin: ICustomCampaignTargetRule = {
  key: "CAFE24_USER_LOGIN",

  checkValidRule({ siteType }) {
    return siteType === "CAFE24";
  },

  getDefaultValue() {
    return {
      type: "CUSTOM",
      key: "CAFE24_USER_LOGIN",
      value: "EVERYONE",
    };
  },

  getShortLabel(target: ICampaignTargetCustom) {
    switch (target.value) {
      case "EVERYONE":
        return null;
      case "NO_LOGIN":
        return "비로그인 사용자";
      case "LOGIN":
        return "로그인 사용자";
      default:
        return null;
    }
  },

  checkPage(condition, { html }) {
    if (condition.key !== "CAFE24_USER_LOGIN") {
      return false;
    }

    if (condition.value === "EVERYONE") {
      return true;
    }

    /**
     * 테스트용 샘플
     *
     * 미로그인
     *  getAdminID : function() {return ''},getMallID
     *
     * 로그인
     *  getAdminID : function() {return ' pboxmvp '},getMallID
     *  작은 따옴표를 기준으로 아이디가 빈칸과 함께 들어옴
     */

    const isLogin =
      /getAdminID : function\(\) \{return '(.+?)'},getMallID/.test(
        html.innerHTML
      );

    switch (condition.value) {
      case "NO_LOGIN":
        return !isLogin;
      case "LOGIN":
        return isLogin;
    }
  },
};

export default cafe24UserLogin;
